import { AllRecruitmentResponseModel, RecruitmentResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { RecruitmentDTO } from './dto/recruitment-dto';
import { RecruitmentRequest } from './dto/recruitment-request';
import { RecruitmentService } from './recruitment.service';
@ApiTags('recruitment')
@Controller('recruitment')
export class RecruitmentController {
    constructor(private recruitmentService: RecruitmentService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/createRecruitment')
    async createRecruitment(@Body() recruitmentDTO: RecruitmentDTO, isUpdate: boolean = false): Promise<RecruitmentResponseModel> {
        try {
            return await this.recruitmentService.createRecruitment(recruitmentDTO, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RecruitmentResponseModel, error);
        }
    }


    @Post('/updateRecruitment')
    async updateRecruitment(@Body() recruitmentDTO: RecruitmentDTO, @Req() request: Request): Promise<RecruitmentResponseModel> {
        try {
            console.log('update Recruitment');
            console.log(request);
            return await this.recruitmentService.createRecruitment(recruitmentDTO, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(RecruitmentResponseModel, error);
        }
    }

    @Post('/getAllRecruitment')
    async getAllRecruitment(): Promise<AllRecruitmentResponseModel> {
        try {
            return await this.recruitmentService.getAllRecruitment();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllRecruitmentResponseModel, error);
        }
    }

    @Post('/getAllActiveRecruitment')
    async getAllActiveRecruitment(@Req() request: Request): Promise<AllRecruitmentResponseModel> {
        try {
            return await this.recruitmentService.getAllActiveRecruitment();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllRecruitmentResponseModel, error)
        }
    }

    @Post('/activateOrDeactivateRecruitment')
    async activateOrDeactivateRecruitment(@Body() recruitmentReq: RecruitmentRequest): Promise<RecruitmentResponseModel> {
        try {
            return await this.recruitmentService.activateOrDeactivateRecruitment(recruitmentReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(RecruitmentResponseModel, err);
        }
    }

    @Post('/getRecruitmentById')
    async getRecruitmentById(@Body() recruitmentReq: RecruitmentRequest): Promise<RecruitmentResponseModel> {
        try {
            return await this.recruitmentService.getActiveCurrencyById(recruitmentReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(RecruitmentResponseModel, err);
        }
    }


}

